import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ModalController } from '@ionic/angular';
import { filter, finalize, switchMap, take, tap } from 'rxjs';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ContractService } from 'src/app/modules/services/contracts/contract.service';
import { DateUtilsService } from 'src/app/modules/services/date-utils/date-utils.service';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { HighwaysService } from 'src/app/modules/services/highways/highways.service';
import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { SegmentsService } from 'src/app/modules/services/segments/segments.service';
import { PerformanceParameterService } from 'src/app/modules/services/performanceParameter/performance-parameter.service';
import { DocumentosService } from 'src/app/modules/services/documentos/documentos.service';
import { IntervenientesService } from 'src/app/modules/services/intervenientes/intervenientes.service';
import { AnotacoesService } from 'src/app/modules/services/anotacoes/anotacoes.service';
import { FormGroup, FormControl } from '@angular/forms';
import { formatarDataType } from '../../fomartData';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-modal-historic-segment',
  templateUrl: './modal-historic-segment.component.html',
  styleUrls: ['./modal-historic-segment.component.scss']
})
export class ModalHistoricSegmentComponent {
  fieldMappings!: { [key: string]: string };
  @Input() data: any;
  dataSource = new MatTableDataSource<any>([]);
  id!: string | null;
  highwayId!: string | null;
  segmentId!: string | null;
  type !: string;
  paginatedHistorics: Historic[] = [];
  pageSize = 10;
  pageIndex = 0;
  totalElements = 0;
  totalPages = Math.ceil(this.totalElements / this.pageSize);
  rangePeriodo = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });  
  dataInicio: string = '';
  dataFinal: string = '';
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  constructor(
    private snackbarService: OpenSnackbarService,
    private dateUtils: DateUtilsService,
    private loadingService: LoadingService,
    private modalCtrl: ModalController,
    private segmentService: SegmentsService,
    private dialogRef: MatDialogRef<ModalHistoricSegmentComponent>,

    @Inject(MAT_DIALOG_DATA) public uploadData: any,
  ) {
    this.rangePeriodo.valueChanges
      .pipe(
        tap((value: any) => {
          if (value.start && value.end) {
            let end = formatarDataType(value.end);
            let start = formatarDataType(value.start);
            this.dataInicio = `${start}`;
            this.dataFinal = `${end}`;
          }

        }),
        filter((value) => value.start != null && value.end != null),
        tap(() => {
          this.loadingService.showLoading();
        }),
        switchMap(async () => this.onGetSegmento(this.id, this.highwayId, this.segmentId))
      )
      .subscribe({
        next: (res: any) => {
          this.loadingService.hideLoading();
        },
        error: (error) => {
          console.error('Erro ao obter o contrato:', error);
        }
      });
  }
  ngOnInit(): void {
    this.fieldMappings = this.uploadData.fieldMappings
    this.type = this.uploadData.type;
    this.id = this.uploadData.id
    this.highwayId = this.uploadData.highwayId;
    this.segmentId = this.uploadData.segmentId;
    switch (this.type) {
      case "segmento":
        this.onGetSegmento(this.id, this.highwayId, this.segmentId);
        break;

    }
    
  }
  onGetSegmento(contractId: any, highwayId: any, segmentId: any) {
    this.loadingService.showLoading();
    this.segmentService.getHistorySegmentos(contractId, highwayId, segmentId, this.pageIndex, this.dataInicio, this.dataFinal).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {
        const { content, pageSize, totalPages, totalElements, pageNumber } = res;
        this.dataSource.data = content;
        this.pageSize = pageSize;
        this.totalPages = totalPages;
        this.totalElements = totalElements;
        this.pageIndex = pageNumber;
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.error.message, 'error');
      }
    })
  }

  formatField(field: string): string {
    return this.fieldMappings[field] || field;
  }

  pageChangeEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    switch (this.type) {
      case "segmento":
        this.onGetSegmento(this.id, this.highwayId, this.segmentId);
        break;

      default:
        console.warn("Tipo desconhecido:", this.type);
        break;
    }

  }
  formatDateToReadable(isoDate: string): string {
    return this.dateUtils.formatDateToReadable(isoDate);
  }
  formatISOToDateHour(isoDate: string): string {
    return this.dateUtils.formatISOToDateHour(isoDate);
  }


  cancel() {
    return this.dialogRef.close({ cancel: 'cancel' });
  }

  confirm() {
    return this.dialogRef.close({ confirm: 'confirm' });
  }
  clearDate(){
    this.rangePeriodo.patchValue({
      start:null,
      end: null,
    })
    this.dataInicio = '';
    this.dataFinal = '';
  }
}
export interface Historic {
  date: Date;
}

export const mockHistorics: Historic[] = [
  { date: new Date('2023-10-01T14:30:00') },
  { date: new Date('2023-10-10T10:45:00') },
  { date: new Date('2023-10-20T09:00:00') }
];